import { Const } from '../lib/const.cls'

import * as RxFactory from '../../../../../store/api/rx-factory'

// vue-webapp server address @see config/prod.env.js, dev.env.js, test.env.js 
// export const FINVIEW_ROOT = process.env.LOCAL_TRADER_SERVER_FULL_ADDRESS
export const FINVIEW_ROOT = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS


import { GET_TOKEN } from '../../../../../types'
export const REDIRECT_BASE_PATH		 				= 		"/"

export const EP_FINVIEW_USER_WATCH_LIST 			    = 		"/api/finview/userwatchlist"
export const EP_FINVASIA_CATEGORIES						= 		"/api/blog/categories"
export const EP_FINVASIA_ARTICELS						= 		"/api/blog/categories/articles"
export const EP_USER_REVIEW								= 		"/api/blog/user/review"
export const EP_GET_USER_ID_FROM_CLIENTCODE				=		"/get/id/from/clientCode"
export const EP_GET_COMPLAINTS_DATA						=		"https://finvasia.com/complaints.json"

const Swal = require('sweetalert2')

let tempTransactionid = ""

export const actions = {
	[Const.RUN_GET_USER_ID_FROM_CLIENTCODE]({commit, state, getters, dispatch}, req){
  		try {			  			
			const self = this;						
			let expressRemote = FINVIEW_ROOT + EP_GET_USER_ID_FROM_CLIENTCODE
			let parametersObj = req.parameter
			parametersObj.pageLoader = true
			delete req.parameter
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {	
				parametersObj.pageLoader = false										
				if(resultSet.info === "OK"){
					if(resultSet.data.length > 0){
						//console.log('-----',resultSet.data[0].id)
						parametersObj.result_user_id = resultSet.data[0].id
						parametersObj.responseMsz = ''
						parametersObj.link = 'https://prism.finvasia.com/register/?franchiseLead='+parametersObj.base64Encode(parametersObj.result_user_id)
						parametersObj.client_code = ''
					}else{
						parametersObj.result_user_id = ''
						parametersObj.responseMsz = "Invalid User Detail, Please check client code"
						parametersObj.msgType = 'error'
					}
					
				}else{
					parametersObj.result_user_id = ''
					parametersObj.responseMsz = resultSet.msg
					parametersObj.msgType = 'error'
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
	// USER RUN_USER_REVIEW
  	[Const.RUN_USER_REVIEW]({commit, state, getters, dispatch}, req){
  		try {			  			
			const self = this;						
			let expressRemote = FINVIEW_ROOT + EP_USER_REVIEW
			let parametersObj = req.parameter
			delete req.parameter
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {											
				if(resultSet.info === "OK"){
					parametersObj.review = (req.review == '1')? 'like' : 'dislike'			
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
	// RUN_USER_WATCH_LISTING
	[Const.RUN_USER_WATCH_LISTING]({commit, state, getters, dispatch}, req){
		try {							
			const self = this;			
			let expressRemote = FINVIEW_ROOT + EP_FINVIEW_USER_WATCH_LIST;			
			
			if(typeof(getters[GET_TOKEN]) != 'undefined' && getters[GET_TOKEN] != ''){		
				let authorizationValidation = ''
				authorizationValidation = { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }
				RxFactory.post(expressRemote, req, authorizationValidation)
				.map(response => response.data)
				.subscribe(
					data => {				
						if ('info' in data) {
							if (data.info === 'OK') {
								commit(Const.SET_USER_WATCH_LISTING, data.data)
							}
							else {
								_cleanUp(commit, data, 200, 'a')				
								commit(Const.SET_USER_WATCH_LISTING, data.data)
							}
						 }else {
							_cleanUp(commit, {info: 'NOK', msg:'Invalid Credentials'}, 200, 'a')
							callback(false, data)
						}
					},
					e => {
						console.log("ERROR", e)
						// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',confirmButtonText: 'logout'})
						// _handleErrorResponse(e, commit)
					}
				)
			}
	
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},
	// USER RUN_CATEGORIES_LISTING
  	[Const.RUN_CATEGORIES_LISTING]({commit, state, getters, dispatch}, req){
  		try {			  			
			const self = this;						
			let expressRemote = FINVIEW_ROOT + EP_FINVASIA_CATEGORIES

			let parametersObj = ""
			if(typeof req.parameters != "undefined" && req.parameters != null && req.parameters != ''){
				parametersObj = req.parameters
				delete req.parameters	
			}

			let res = Const.SET_CATEGORIES_LISTING;			
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {											
				if(resultSet.info === "OK"){	
					if(parametersObj){												
						setTimeout(function(){ 							
							parametersObj.articlesInfo(parametersObj.$route.params.article)
						}, 500);						
					}
					commit(res, resultSet.data)									
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  	// USER RUN_ARTICELS_LISTING
  	[Const.RUN_ARTICELS_LISTING]({commit, state, getters, dispatch}, req){
  		try {				  			
			const self = this;						
			let expressRemote = FINVIEW_ROOT + EP_FINVASIA_ARTICELS
			let res = Const.SET_ARTICELS_LISTING;			
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {							
				if(resultSet.info === "OK"){														
					commit(res, resultSet.data)									
				}
			});

		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_COMPLAINTS_DATA]({commit, state, getters, dispatch}, req){
  		try {				  			
			const self = this;						
			let expressRemote = EP_GET_COMPLAINTS_DATA
			let res = Const.SET_COMPLAINTS_DATA;			
			// _vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {							
			// 	if(resultSet.info === "OK"){	
			// 		console.log('action',resultSet.data)													
			// 		commit(res, resultSet.data)									
			// 	}
			// });




			RxFactory.getJson( EP_GET_COMPLAINTS_DATA, {}, '')
				.map(response => response.data)
				.subscribe(
					data => {		
						console.log(data)	
						if(Object.keys(data).length > 0)	{
							commit(res, resultSet.data)	
						}else{
							commit(res,{})	
						}
						// if ('info' in data) {
						// 	if (data.info === 'OK') {
						// 		console.log(data)
						// 		// callback(false, data)
						// 	}
						// 	else {
						// 		_cleanUp(commit, data, 200, 'a')				
						// 		callback(false, data)
						// 	}
					 // 	}else {
						// 	_cleanUp(commit, {info: 'NOK', msg:'Invalid Credentials'}, 200, 'a')
						// 	callback(false, data)
						// }
					},
					e => {
						console.log("ERROR", e)
						//Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',confirmButtonText: 'logout'})
						//_handleErrorResponse(e, commit)
					}
				)

		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
}

function _vueExecuteProcess(expressRemote, req, commit, getters, callback){	
	//url, params, headers	

	
	let authorizationValidation = ''
	if(typeof(getters) != 'undefined' && getters != ''){		
		authorizationValidation = { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }
	}else{		
		authorizationValidation = { 'Content-Type': 'multipart/form-data' }
	}
	RxFactory.post(expressRemote, req, authorizationValidation)
		.map(response => response.data)
		.subscribe(
			data => {				
				if ('info' in data) {
					if (data.info === 'OK') {
						callback(false, data)
					}
					else {
						_cleanUp(commit, data, 200, 'a')				
						callback(false, data)
					}
			 	}else {
					_cleanUp(commit, {info: 'NOK', msg:'Invalid Credentials'}, 200, 'a')
					callback(false, data)
				}
			},
			e => {
				console.log("ERROR", e)
				//Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',confirmButtonText: 'logout'})
				//_handleErrorResponse(e, commit)
			}
		)		
	//_cleanUp(commit, req, 200, 'a')
}

function _cleanUp (commit, msg, status, loaderId) {
  	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  	// toggle loader 'a', 'b', 'c'
	// commit(SET_TOGGLE_LOADER, loaderArr)
 	commit("SET_INFO", msg)
}

function _handleErrorResponse (e, commit) {
  	let response = {info: 'NOK', msg: 'Service not available'}
  	if (typeof e.response === 'undefined') {
    	try {
      		const statusCheck = e.toString().toLowerCase()
	      	if (statusCheck.indexOf('network') > -1) {
	        	response = {info: 'NOK', msg: 'Network Error'}
	      	}
	      	console.log("statusCheck", statusCheck)
    	} catch (e) {}
  	} else {
  	 	console.log("statusCheck", e.response.status)
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}

function _handleLogout (data, commit, options) {
	console.log('_handleLogout args', data, options)
	let user = {}
	const state = []
	// set state (user, token)
	//commit(Const.SET_TRADER_BASIC_INFO, state)

	// save state to local storage (user)
	window.sessionStorage.setItem('user_info', "")

	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	// route back to blockmaze portal
	if (options.forward === true) {
		//window.location.replace("/")
		//options.router.replace({ path : "/prism" })
	}
}


// WEBPACK FOOTER //
// ./src/plugins/finView/provider/candle-history/store-addons/actions.js